import { z } from 'zod';

const MOCK_API_KEY = 'mock-api-key';

const schema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1).default(MOCK_API_KEY),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1).default('mock-domain.firebaseapp.com'),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1).default('wss-calculator-mock'),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1).default('wss-calculator-mock.appspot.com'),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1).default('000000'),
  VITE_FIREBASE_APP_ID: z.string().min(1).default('1:000:web:000'),
  VITE_APP_CHECK_SITE_KEY: z.string().min(1).default('mock-site-key'),
  // Sentry — all optional. Empty DSN disables error reporting entirely (the
  // offline-dev / local default). The DSN is a public client identifier, not a
  // secret, so it is baked into the bundle at build time like the other VITE_*.
  VITE_SENTRY_DSN: z.string().default(''),
  VITE_SENTRY_ENVIRONMENT: z.string().default(''),
  VITE_SENTRY_RELEASE: z.string().default(''),
  // 'true' points the client SDKs at the local Firebase Emulator Suite
  // (dev-only — see docs/superpowers/plans/archive/2026-06-12-retire-offline-dual-path.md).
  VITE_USE_EMULATORS: z.string().default(''),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('[env] invalid VITE_* config:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid VITE_* environment configuration. See console.');
}

export const env = parsed.data;

/** True when no real Firebase order is configured (dev fallback values). */
export const hasRealFirebaseConfig = (): boolean => env.VITE_FIREBASE_API_KEY !== MOCK_API_KEY;

/** Vite-injected build flag. Wrapped here so non-firebase code can check it
 *  without sprinkling `import.meta.env.DEV` everywhere. */
export const isDev = (): boolean => import.meta.env.DEV;
